export class SecurityFindingsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "SnapshotIdFilters",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "FindingResourceFilters",
            "format": ""
        },
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "DetectorTypeFilters",
            "format": ""
        },
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "EvidenceTypeFilters",
            "format": ""
        },
        {
            "name": "objectType",
            "baseName": "objectType",
            "type": "FindingObjectTypeFilters",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "FreeTextFilters",
            "format": ""
        },
        {
            "name": "snapshotTime",
            "baseName": "snapshotTime",
            "type": "SnapshotTimeFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityFindingsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
